import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { ElementValueModel } from 'src/app/shared/models/Application.model';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { MiniLoaderService } from '../mini-loader/mini-loader.service';
import { lastValueFrom } from 'rxjs';
import { HelperService } from '../../services/Helper.service';
import { AppVersionResponseDto } from './app-version.dto';
import { AppVersionModalService } from './version-modal.service';

@Component({
  selector: 'app-version-modal',
  templateUrl: './version-modal.component.html',
  styleUrls: ['./version-modal.component.scss'],
})
export class VersionModalComponent implements OnInit {
  modalData: AppVersionResponseDto[];
  modalIcons: ElementValueModel[];
  logo: ElementValueModel;

  @ViewChild(MatAccordion) accordion: MatAccordion;

  constructor(
    public appConfService: AppConfigService,
    private appVersionModalService: AppVersionModalService,
    private loaderService: MiniLoaderService,
  ) {
    this.modalIcons = new Array<ElementValueModel>();
    this.logo = new ElementValueModel({});
  }

  async fetchData() {
    try {
      this.loaderService.loader = true;
      this.modalData = await lastValueFrom(
        this.appVersionModalService.getData(),
      );
    } catch (error) {
      this.modalData = [];
      console.log(error);
    } finally {
      this.loaderService.loader = false;
    }
  }

  async ngOnInit() {
    this.modalIcons = this.appConfService.get()?.elements?.modal?.icons;
    this.logo = this.appConfService.get()?.elements?.logo;
    await this.fetchData();

    this.accordion?.closeAll();
  }
}
